// extracted by mini-css-extract-plugin
export default {"container":"Event_container__jknLX","mask":"Event_mask__rxqSr"};